import { schema } from 'normalizr';

const InventoryLocationSchema = new schema.Entity('inventoryLocations', {});
export default InventoryLocationSchema;
